var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",staticClass:"channelCode",attrs:{"id":"1","show-tool-bar":false,"no-selection":true,"url":{
      data: _vm.requestUrl + '/salesperson/chat-user-bind/list'
    },"setting":{
      search: [
        {
          type: 'input',
          key: 'chat_name',
          name: '群名称',
          placeholder: '输入群名称'
        },
        {
          type: 'input',
          key: 'chat_id',
          name: '群ID',
          placeholder: '输入群ID多个用逗号分隔'
        }
      ]
    },"title":"数据","columns":_vm.columns,"actions":_vm.actions}}),_c('SpBulkImport',{attrs:{"file-type":"characteristic_group","title":"批量导入绑定社群"},on:{"saveImportAction":_vm.saveImportAction},model:{value:(_vm.importVisible),callback:function ($$v) {_vm.importVisible=$$v},expression:"importVisible"}},[_c('div',[_vm._v(" 批量导入说明： "),_c('br'),_vm._v(" 1、下载社群绑定模版文件"),_c('br'),_vm._v(" 2、根据填写要求填写门店绑定的社群，上传并导入文件，文件格式必须为xlsx"),_c('br'),_vm._v(" 3、单次上传xlsx最大条目数（行数）为5000，超出请安文件分批上传"),_c('br'),_vm._v(" 4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }